export default __webpack_public_path__ + "6485717a7a879c9e441ddbe75b00d0bf.png";